(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-ps-community"] && !Shopify.designMode) return;
  try {
    
/* Count-up der Stat-Zahlen beim Scrollen (transform/opacity-frei, off-main-thread-freundlich) */
(function () {
  function initCounters(root) {
    var nodes = root.querySelectorAll('[data-count-to]:not([data-counted])');
    if (!nodes.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.setAttribute('data-counted', ''); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; obs.unobserve(el); el.setAttribute('data-counted', '');
        var target = parseFloat(el.getAttribute('data-count-to')) || 0;
        var raw = el.getAttribute('data-count-raw') || String(target);
        var prefix = (raw.match(/^[^0-9]*/) || [''])[0];
        var suffix = (raw.match(/[^0-9]*$/) || [''])[0];
        var dur = 1100, start = null;
        function tick(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3); /* easeOutCubic */
          var val = Math.round(target * eased);
          el.textContent = prefix + val.toLocaleString('de-DE') + suffix;
          if (p < 1) requestAnimationFrame(tick); else el.textContent = raw;
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    nodes.forEach(function (n) { io.observe(n); });
  }
  /* Bewertungs-Rotator: alle Reviews im DOM, JS zeigt N und schaltet zufaellig durch */
  /* Reviews-Karussell: alle Karten in einer Schiene, schaltet wie ein Rad durch.
     Eine Karte gleitet links raus, die naechste schwebt rechts rein (Endlos-Loop). */
  function initCarousel(root) {
    if (root.__psCarousel) return;
    var track = root.querySelector('.ps-comm__quotes');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.ps-comm__quote'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || cards.length < 2) return; // statisches Raster behalten
    root.__psCarousel = true;
    root.classList.add('is-carousel');

    var base = (parseFloat(root.getAttribute('data-interval')) || 4.5) * 1000;
    var paused = false, hidden = false, animating = false;
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    document.addEventListener('visibilitychange', function () { hidden = document.hidden; });

    function stepPx() {
      var first = track.firstElementChild;
      if (!first) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function advance() {
      if (paused || hidden || animating) return;
      var dist = stepPx();
      if (!dist) return;
      animating = true;
      track.style.transition = 'transform 620ms var(--ps-comm-ease, cubic-bezier(0.23,1,0.32,1))';
      track.style.transform = 'translateX(' + (-dist) + 'px)';
      var done = function () {
        track.removeEventListener('transitionend', done);
        // erste Karte ans Ende verschieben + Transform zuruecksetzen (kein Sprung)
        track.style.transition = 'none';
        track.appendChild(track.firstElementChild);
        track.style.transform = 'translateX(0)';
        void track.offsetWidth; // Reflow
        animating = false;
      };
      track.addEventListener('transitionend', done);
    }

    window.setInterval(advance, base);
  }

  function boot() {
    document.querySelectorAll('.ps-comm').forEach(initCounters);
    document.querySelectorAll('[data-ps-comm-rotator]').forEach(initCarousel);
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
